export const formatCurrency = (value: number, currency = "EUR", locale = "pt-PT"): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
